import templateUrl from 'emun.salesrep/territory-manager/region/region-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import RegionPrompt from "emun.salesrep/territory-manager/region/region-prompt";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";

class RegionListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.query = new AutoQuery({
			url: 'QueryRegions.json',
			autoLoad: true,
			hideLeftNav: true
		});
		let $rootScope = resolve("$rootScope");
		$rootScope.$on("regionSaved", () => $ctrl.query.load(true));
    }
	//create() {
	//	const $ctrl = this;
	//	RegionPrompt.open({ region: "", regionId: "" });
	//}
	create() {
		const $ctrl = this;
		$ctrl.$state.transitionTo("region", { regionId: 'create' });
	}

	edit(region) {
		const $ctrl = this;
		RegionPrompt.open({ region: region, regionId: region.id });
	}

	delete(region) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to delete " + region.name, "Delete Region?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteRegion.json", region)
					.then(function () {
						return $ctrl.query.load(true);
					})
					.catch(

					);
			});
	}
}

let RegionList = {
	controller: RegionListController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}

export default RegionList;
